/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { ChainlinkPriceFeed } from "./ChainlinkPriceFeed";

export class ChainlinkPriceFeedFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<ChainlinkPriceFeed> {
    return super.deploy(overrides || {}) as Promise<ChainlinkPriceFeed>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ChainlinkPriceFeed {
    return super.attach(address) as ChainlinkPriceFeed;
  }
  connect(signer: Signer): ChainlinkPriceFeedFactory {
    return super.connect(signer) as ChainlinkPriceFeedFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ChainlinkPriceFeed {
    return new Contract(address, _abi, signerOrProvider) as ChainlinkPriceFeed;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_aggregator",
        type: "address",
      },
    ],
    name: "addAggregator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
    ],
    name: "getAggregator",
    outputs: [
      {
        internalType: "contract AggregatorV3Interface",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
    ],
    name: "getLatestTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_numOfRoundBack",
        type: "uint256",
      },
    ],
    name: "getPreviousPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_numOfRoundBack",
        type: "uint256",
      },
    ],
    name: "getPreviousTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_interval",
        type: "uint256",
      },
    ],
    name: "getTwapPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "priceFeedDecimalMap",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "priceFeedKeys",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "priceFeedMap",
    outputs: [
      {
        internalType: "contract AggregatorV3Interface",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
    ],
    name: "removeAggregator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_roundId",
        type: "uint256",
      },
    ],
    name: "setLatestData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
